import React from "react"
import PropTypes from "prop-types"
import { NotificationsList } from "components"
import { Section, H2, Space, Content } from "AtomicComponents"

const MyMazdaNotifications = props => (
  <Section padding backgroundColor="#ffffff">
    <H2 withDetails>{props.heading}</H2>
    <Space />
    <Content
      xmlString={props.description} textAlign="center" />
    <NotificationsList items={props.notificationItems} />
  </Section>
)

MyMazdaNotifications.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  notificationItems: PropTypes.array
}

export default MyMazdaNotifications



// WEBPACK FOOTER //
// ./src/blocks/mymazda/notifications/index.jsx